import React from 'react';
import { Typography, Paper, Box, useTheme } from '@mui/material';

const PageHeader = ({ title, subtitle, action, logo, centerImage, showLogo = false }) => {
  const theme = useTheme();
  
  return (
    <Paper 
      elevation={1} 
      sx={{ 
        padding: 2, 
        marginBottom: 3,
        borderRadius: 2,
        background: theme.palette.background.paper
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* Left side with title */}
        <Box display="flex" alignItems="center" sx={{ flex: 1 }}>
          {title && (
            <Box
              sx={{
                position: 'relative',
                '&:before': {
                  content: '""',
                  position: 'absolute',
                  bottom: '-8px',
                  left: '0',
                  width: '50%',
                  height: '4px',
                  background: 'linear-gradient(90deg, #1976d2 0%, #5cb85c 100%)',
                  borderRadius: '4px',
                }
              }}
            >
              <Typography 
                variant="h3" 
                component="h1" 
                sx={{ 
                  fontWeight: 700, 
                  background: 'linear-gradient(90deg, #1976d2 0%, #334880 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mr: action ? 4 : 0,
                  letterSpacing: '2px',
                  fontFamily: '"Poppins", "Montserrat", "Roboto", sans-serif',
                  textShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                  fontSize: { xs: '2rem', sm: '2.4rem', md: '2.7rem' },
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    textShadow: '0px 4px 8px rgba(0,0,0,0.15)'
                  }
                }}
              >
                <Box component="span" sx={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  mr: 1.5,
                  color: '#1976d2',
                  WebkitTextFillColor: '#1976d2'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="3" y1="9" x2="21" y2="9"></line>
                    <line x1="9" y1="21" x2="9" y2="9"></line>
                  </svg>
                </Box>
                {title}
              </Typography>
            </Box>
          )}
          {subtitle && (
            <Box sx={{ ml: 2, display: { xs: 'none', md: 'block' } }}>
              <Typography 
                variant="subtitle1" 
                color="textSecondary"
              >
                {subtitle}
              </Typography>
            </Box>
          )}
          {action && (
            <Box sx={{ ml: 2 }}>
              {action}
            </Box>
          )}
        </Box>
        
        {/* Center with logo */}
        {showLogo && logo && (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            sx={{ 
              flex: 1,
              height: '120px',
              maxWidth: '300px'
            }}
          >
            {typeof logo === 'string' ? (
              <img 
                src={logo} 
                alt="College Logo" 
                style={{ 
                  maxHeight: '100%', 
                  maxWidth: '100%', 
                  objectFit: 'contain' 
                }} 
              />
            ) : logo}
          </Box>
        )}
        
        {/* Right side with timetable image */}
        {centerImage && (
          <Box 
            display="flex" 
            justifyContent="flex-end" 
            alignItems="center" 
            sx={{ 
              flex: 1,
              height: '100px',
              padding: 1
            }}
          >
            {typeof centerImage === 'string' ? (
              <img 
                src={centerImage} 
                alt="Timetable Image" 
                style={{ 
                  maxHeight: '100%', 
                  maxWidth: '100%', 
                  objectFit: 'contain',
                  borderRadius: '4px'
                }} 
              />
            ) : centerImage}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default PageHeader;
